import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ss-www-ampersand-logo',
  imports: [],
  templateUrl: './ampersand-logo.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AmpersandLogoComponent {}
